import { VictoryLegend } from 'victory';
import { getLineGraphProps } from './helpers/getLineGraphProps';
import { splitString } from '../helpers/helpers';
import { fontStyle } from '../cbsGraph.config';
import { Label } from '../Label';

const chartLegendLineLength = 25;

export const Legend = ({
	dimensionInfo,
}: {
	dimensionInfo: ReturnType<typeof getLineGraphProps>['dimensionInfo'];
}) => (
	<VictoryLegend
		titleComponent={
			// I don't know why but this is needed
			// but it prevents the legend from crashing
			<></>
		}
		orientation="horizontal"
		gutter={20}
		x={6}
		y={0}
		symbolSpacer={12}
		style={{
			labels: fontStyle,
		}}
		data={dimensionInfo.map(({ dimensionLabel, chartColor }) => ({
			name: splitString(dimensionLabel, chartLegendLineLength).join('\n'),
			symbol: {
				type: chartColor.symbol,
				fill: chartColor.color,
			},
		}))}
		labelComponent={<Label verticalAnchor={'start'} dy={-8} />}
	/>
);
